import * as React from 'react';
export const CorePopoverContext = React.createContext({
    excludeClickOutsideClasses: [],
});
//# sourceMappingURL=CorePopoverContext.js.map